var Base64 = require("./base64bak").Base64;

/*
 * 加密算法1：经过3步处理
 * 1、base64编码
 * 2、将编码后等号个数替换全部等号
 * 3、替换base64字符串中：+ -> -，/ -> _
 * 4、将字符串折半对换
 */

var encrypt = function (str) {
    if (str == null || str.length == 0)
        return "";
    // console.log("原始字符串：" + str);
    //步骤1
    var strBase64 = Base64.encode(str);
    // console.log("base64编码后：" + strBase64);

    //步骤2
    var equalCharCount = 0;
    var eqIndex = strBase64.indexOf("=");
    if (eqIndex !== -1) {
        equalCharCount = strBase64.length - eqIndex;
        strBase64 = strBase64.substring(0, eqIndex);
    }
    strBase64 += equalCharCount;
    // console.log("base64编码等号个数填补字符串最后一位后：" + strBase64);

    //步骤3
    strBase64 = strBase64.replace(/\+/g, "-").replace(/\//g, "_");
    // console.log("替换base64字符串中：+ -> -，/ -> _后：" + strBase64);

    //步骤4
    var halfIndex = Math.floor(strBase64.length / 2);
    var beforeStr = strBase64.substring(halfIndex);
    var afterStr = strBase64.substring(0, halfIndex);
    // console.log("前半部分：" + afterStr);
    // console.log("后半部分：" + beforeStr);
    var strHalfSwap = beforeStr + afterStr;
    // console.log("折半对换（向下取整）后：" + strHalfSwap);

    return strHalfSwap;
};

//算法版本
encrypt.getVersion = function () {
    return 'j1.0';
};

module.exports = encrypt;
